import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';


@Component({
  selector: 'app-full-layout',
  templateUrl: './full.component.html',
  styleUrls: ['./full.component.scss']
})
export class FullComponent implements OnInit {

  constructor(public router: Router, private broadCast:BroadCastServiceService) { }

  isComponent=""
  subscription: any;

  ngOnInit() {
    this.subscription = this.broadCast
    .getMessage()
    .subscribe((message) => {
      if (message)  {
       this.isComponent=message;
      }
    });

    if (this.router.url === '/') {
      this.router.navigate(['/landing-page']);
    }
  }
}
